// Angular
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
// RxJS
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
// NGRX
import { select, Store } from '@ngrx/store';
// Auth reducers and selectors
import { AppState} from '../../reducers';
import { isLoggedOut } from '../_selectors/auth.selectors';

@Injectable()
export class LoginGuard implements CanActivate {
    constructor(private store: Store<AppState>, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return this.store
            .pipe(
                select(isLoggedOut),
                tap(isLoggedOut => {
                    if (!isLoggedOut) {
                        this.router.navigateByUrl('/dashboard');
                    }
                })
			)
    }
}
